import { Component, Output, EventEmitter, Input } from '@angular/core';
import { OrdersAssignmentService } from '@app/shared/services/order-assigment.service';
import { BranchViewModel } from '@app/shared/models/branch-view.model';
import { RestaurantsType } from '@app/shared/models/restaurant-type-names';

@Component({
  selector: 'app-filtering-by-branch',
  templateUrl: './filtering-by-branch.component.html',
  styleUrls: ['./filtering-by-branch.component.scss']
})
export class FilteringByBranchComponent {
  @Output() selectedBranchType: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedBranch: EventEmitter<any> = new EventEmitter<any>();
  @Output() searchEvent: EventEmitter<string> = new EventEmitter<string>();
  @Input() data: Array<any> = [];
  @Input() showSearch: boolean;
  @Input() showEmptyMessage = true;
  branches: BranchViewModel[] = [];
  restauranTypes = RestaurantsType;
  filters: any = {
    restaurantType: '',
    branch: null,
    search: ''
  };

  constructor(private orderAssignmentService: OrdersAssignmentService) { }

  getBranches(option: string): void {
    this.filters.branch = null;
    this.filters.search = '';
    this.selectedBranchType.emit(this.filters.restaurantType);
    this.orderAssignmentService.getBranches(option).subscribe(branches => (this.branches = branches));
  }

  selectBranch(): void {
    this.filters.search = '';
    this.selectedBranch.emit(this.filters.branch.id);
  }

  search(): void {
    this.searchEvent.emit(this.filters.search.trim());
  }
}
